export default {
  'component.takeover.title': 'Overtakelse',
  'component.takeover.description':
    'Når du går gjennom hjemmet med kjøperen, må du fylle ut en digital anskaffelsesprotokoll. Blant annet tar det deg gjennom kontroll over hjemmet, lesing av strømmålere og overlevering av nøkler.',
  'component.takeover.startacquisition': 'Start anskaffelses',
};
